// ANCHOR Model
import createModel, { createSelector, createSelectors } from 'react-scoped-model';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getFormById } from '@lyon/utils/api/forms';

// ANCHOR Utils
import { tuple } from '@lyon/utils/tuple';

interface IProps {
  id: string;
}

export const FormData = createModel(({ id }: IProps) => {
  const response = useSWR(
    `/forms/${id}`,
    () => getFormById({ id }),
  );

  return {
    ...response,
  };
}, {
  displayName: 'Models.FormData',
});

export const useFormData = createSelector(
  FormData,
  ({ data }) => data,
);

export const useFormDataID = createSelector(
  FormData,
  ({ data }) => data?.id,
);

export const useFormDataTitle = createSelector(
  FormData,
  ({ data }) => data?.title,
);

export const useFormDataType = createSelector(
  FormData,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  ({ data }) => data?.type,
);

export const useFormDataTimeLimit = createSelector(
  FormData,
  ({ data }) => data?.timeLimit,
);

export const useFormDataShuffleQuestion = createSelector(
  FormData,
  ({ data }) => data?.shuffleQuestion,
);

export const useFormDataStartAnswering = createSelectors(
  FormData,
  ({ data }) => tuple(
    data?.accessCode,
    data?.allowedAttempts,
    data?.isLocked,
    data?.isPractice,
  ),
);

export const useFormDataRetake = createSelectors(
  FormData,
  ({ data }) => tuple(
    data?.allowedAttempts,
    data?.isLocked,
    data?.isPractice,
  ),
);

export const useFormDataCanGoBack = createSelector(
  FormData,
  ({ data }) => data?.canGoBack,
);

export const useFormDataTextSelection = createSelector(
  FormData,
  ({ data }) => data?.textSelection,
);

export const useFormMutate = createSelector(
  FormData,
  ({ mutate }) => mutate,
);
